module.exports = __webpack_public_path__ + "static/img/Group 356.353b5486.png";